import React from 'react';
import I18n from 'i18n-js';

import SiteModule from '@reverbdotcom/commons/src/components/site_module';
import FormGroup from '@reverbdotcom/commons/src/components/form_group';
import SanitizedRender from '@reverbdotcom/commons/src/components/sanitized_render';
import { RCTag } from '@reverbdotcom/commons/src/rc/RCTag';

import URLHelpers from '../../shared/url_helpers';

interface IProps {
  prefersReverbShippingLabel: boolean;
}

function RSLSelectorFooterModule() {
  return (
    <ul className="rsl-selector-module__list-group">
      <li className="rsl-selector-module__list-item">
        {I18n.t('discovery.dashboard.selling.shippingLabels.reverbShippingLabelSelector.valueProps.savePrice')}
      </li>
      <li className="rsl-selector-module__list-item">
        <SanitizedRender
          htmlTag="div"
          html={I18n.t('discovery.dashboard.selling.shippingLabels.reverbShippingLabelSelector.valueProps.safeShipping',
            {
              linkOpen: `<a href=${URLHelpers.sellingSafeShippingInfoPath} target="_blank">`,
              linkClose: '</a>',
            },
          )}
        />
      </li>
      <li className="rsl-selector-module__list-item">
        {I18n.t('discovery.dashboard.selling.shippingLabels.reverbShippingLabelSelector.valueProps.printLabel')}
      </li>
    </ul>
  );
}

export const COMPONENT_NAME = 'ReverbShippingLabelSelector';

export default function ReverbShippingLabelSelector({ prefersReverbShippingLabel = true }: IProps) {
  const [prefersRSL, setPrefersRSL] = React.useState(prefersReverbShippingLabel);

  function handleToggle() {
    setPrefersRSL(!prefersRSL);
  }

  return (
    <div className="mb-2">
      <FormGroup
        label={I18n.t('discovery.dashboard.selling.shippingLabels.reverbShippingLabelSelector.title')}
      >
        <SiteModule footerContent={RSLSelectorFooterModule()}>
          <div className="label-with-radio">
            <input
              onChange={() => handleToggle()}
              type="radio"
              name="product[prefers_reverb_shipping_label]"
              id="rsl-radio"
              checked={prefersRSL}
              value="1"
              required
            />
            <label className="size-110" htmlFor="rsl-radio">
              <span className="mr-1">
                {I18n.t('discovery.dashboard.selling.shippingLabels.reverbShippingLabelSelector.revebShippingLabel')}
              </span>
              <RCTag variant="highlight">
                {I18n.t('discovery.dashboard.selling.shippingLabels.reverbShippingLabelSelector.tag')}
              </RCTag>
            </label>
            <p className="rsl-selector-module__help-text">
              {I18n.t('discovery.dashboard.selling.shippingLabels.reverbShippingLabelSelector.helpText')}
            </p>
          </div>
        </SiteModule>
        <SiteModule>
          <div className="label-with-radio">
            <input
              onChange={() => handleToggle()}
              type="radio"
              name="product[prefers_reverb_shipping_label]"
              id="custom-label-radio"
              checked={!prefersRSL}
              value="0"
              required
            />
            <label className="size-110" htmlFor="custom-label-radio">
              {I18n.t('discovery.dashboard.selling.shippingLabels.reverbShippingLabelSelector.customLabel')}
            </label>
          </div>
        </SiteModule>
      </FormGroup>
    </div>
  );
}
